var map = {
	"./arrow.svg": 42,
	"./email.svg": 54,
	"./github.svg": 32,
	"./linkedin.svg": 53,
	"./minesweeper.svg": 121,
	"./pdf.svg": 55,
	"./portfolio-html.svg": 122,
	"./portfolio-rn.svg": 123,
	"./portrait.svg": 52,
	"./raurustrike.svg": 124,
	"./retroroyale.svg": 125,
	"./sapporobestlap.svg": 126,
	"./svgconfig.txt": 127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 120;